export const getDateToday = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth();
  const year = today.getFullYear();

  // mm/dd/yyyy
  return `${month + 1}/${day}/${year}`;
};

export const getDateDiff = (dateStr1, dateStr2) => {
  if (!dateStr1 || !dateStr2) return null;

  const d1 = new Date(dateStr1);
  const d2 = new Date(dateStr2);

  const diff = d2.getTime() - d1.getTime();

  return diff / (1000 * 60 * 60 * 24);
};

function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}
export const convertMsToTime = (milliseconds) => {
  let seconds = Math.floor(milliseconds / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);

  seconds = seconds % 60;
  minutes = minutes % 60;

  // 👇️ If you don't want to roll hours over, e.g. 24 to 00
  // 👇️ comment (or remove) the line below
  // commenting next line gets you `24:00:00` instead of `00:00:00`
  // or `36:15:31` instead of `12:15:31`, etc.
  hours = hours % 24;

  return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(
    seconds
  )}`;
}